import { useEffect, useRef, useState } from "react";
import { api, API } from "@/lib/api";

const isDownStatus = (s) => (s >= 502 && s <= 504) || (s >= 520 && s <= 530);

const pingHealth = () =>
  fetch(`${API}/health`, { cache: "no-store", credentials: "omit" })
    .then((r) => r.ok)
    .catch(() => false);

// Full-screen "Signal lost" overlay shown when the API is unreachable; form state underneath is preserved.
export default function SignalLost() {
  const [down, setDown] = useState(false);
  const confirming = useRef(false);

  useEffect(() => {
    const confirmDown = async () => {
      if (confirming.current) return;
      confirming.current = true;
      if (!(await pingHealth())) setDown(true);
      confirming.current = false;
    };
    const id = api.interceptors.response.use(
      (res) => res,
      (err) => {
        const status = err?.response?.status;
        if (!err?.response || isDownStatus(status)) confirmDown();
        return Promise.reject(err);
      }
    );
    confirmDown();
    const onMsg = (e) => {
      if (e.origin === window.location.origin && e.data === "wlou:signal-restored") setDown(false);
    };
    window.addEventListener("message", onMsg);
    return () => {
      api.interceptors.response.eject(id);
      window.removeEventListener("message", onMsg);
    };
  }, []);

  if (!down) return null;
  return (
    <iframe
      title="Signal lost"
      src="/offline.html?embed=1"
      data-testid="signal-lost-overlay"
      className="fixed inset-0 w-full h-full z-[9999] border-0 bg-[#0D110C]"
    />
  );
}
